import React, { useEffect, useState } from 'react';
import './index.less';
import TemplatePreviewChart from '../template-preview-chart';
import TemplateImageLegend from '../template-imageLegend';
import { IAgriAlertTranslateResModel, IGetHistoricalOrForecastDataResModel } from '@/util/Request/agrialert/responseType';
import { IForecastChartOrTableModel } from '@/util/Request/agrialert/requestType';
import { getWeekTranslate } from '../../initData';
import { agriAlertGetForecast8HourlyData, agriAlertGetForecastData, agriAlertGetForecastHourlyData, agriAlertGetHistoricalData } from '@/util/Request/agrialert';
import moment from 'moment';
import IF from '@/components/IF';
import { AgregationEnum, ChartsOrTablesEnum, HistoricalOrForecastEnum, SpeedUnitEnum } from '@/page/Agrialert/template-management/template-management';

interface IProp{
    showForecast: boolean;
    translateValue: IAgriAlertTranslateResModel;
    selectedForecastChartsOrTables?: IForecastChartOrTableModel[];
    forecastType: string; // value is Charts Or Tables
    // lant, lng and unit,lanauage
    lat: number;
    lng: number;
    unit?: string;
    language?: string;
}

export const enum WindOrWeatherSelectEnum{
    HAVEWIND = 40,
    HAVEWEATHER = 50,
    HAVENONE = 0,
    HAVEBOTH = 80
}

const TemplateForecast = (prop:IProp)=>{

    const {
        showForecast,
        translateValue,
        selectedForecastChartsOrTables,
        lat,
        lng,
        language,
        unit,
        forecastType
    } = prop;

    // For Forecast Tables
    const [finalForecastTableDailyData,setFinalForecastTableDailyData] = useState<IGetHistoricalOrForecastDataResModel[]>([]);
    const [finalForecastTable8HourlyData,setFinalForecastTable8HourlyData] = useState<IGetHistoricalOrForecastDataResModel[]>([]);
    const [finalForecastTableHourlyData,setFinalForecastTableHourlyData] = useState<IGetHistoricalOrForecastDataResModel[]>([]);
    // For Forecast Charts
    const [finalForecastChartDailyData,setFinalForecastChartDailyData] = useState<IGetHistoricalOrForecastDataResModel[]>([]);
    const [finalForecastChart8HourlyData,setFinalForecastChart8HourlyData] = useState<IGetHistoricalOrForecastDataResModel[]>([]);
    const [finalForecastChartHourlyData,setFinalForecastChartHourlyData] = useState<IGetHistoricalOrForecastDataResModel[]>([]);
    // For show Speed Image legend
    const [isShowSpeedLegendChartDaily,setIsShowSpeedLegendChartDaily] = useState(false);
    const [isShowSpeedLegendChart8Hourly,setIsShowSpeedLegendChart8Hourly] = useState(false);
    const [speedType,setSpeedType] = useState(null);
    const [windOrWeatherDailySelect,setWindOrWeatherDailySelect] = useState<WindOrWeatherSelectEnum>(WindOrWeatherSelectEnum.HAVENONE);
    const [windOrWeather8HourlySelect,setWindOrWeather8HourlySelect] = useState<WindOrWeatherSelectEnum>(WindOrWeatherSelectEnum.HAVENONE);

    const mergedForecastAggregationReq = selectedForecastChartsOrTables.reduce((acc,current)=>{
        const existingGroup = acc.find(item => item.aggregation === current.aggregation);

        if (existingGroup) {
            // 如果已经存在相同的 groupId，则拼接 StressAlertReq
            existingGroup.variables += `;${current.variables}`;
        } else {
            // 如果不存在相同的 groupId，则添加新的项
            acc.push({ ...current });
        }

        return acc;
    },[] as IForecastChartOrTableModel[]);

    console.log('forecast merged,',mergedForecastAggregationReq);
    console.log('forecast merged data finalForecastTableDailyData, ',finalForecastTableDailyData);
    console.log('forecast merged data finalForecastTableHourlyData, ',finalForecastTableHourlyData);
    console.log('forecast merged data finalForecastChartDailyData, ',finalForecastChartDailyData);
    console.log('forecast merged data finalForecastChartHourlyData, ',finalForecastChartHourlyData);

    const getForecastChartsOrTablesListDataFunc = async () => {
        try {
            let tmpIsShowSpeedLegendChartDaily = isShowSpeedLegendChartDaily;
            let tmpIsShowSpeedLegendChart8Hourly = isShowSpeedLegendChart8Hourly;
            // 创建一个数组来存储带有上下文信息的结果
            const promises = mergedForecastAggregationReq?.map(async (item) => {
                let result;
                if (item?.aggregation === AgregationEnum.DAILY) {
                    let tmpIsWind = false;
                    let tmpIsWeather = false;
                    item?.variablesForArray?.forEach((item)=>{
                        if(item === 'WindDirection_DailyAvg (Deg)'){
                            tmpIsShowSpeedLegendChartDaily = true;
                            tmpIsWind = true;
                        }
                        if(item === 'PictoCode_Daily'){
                            tmpIsWeather = true;
                        }
                        if(tmpIsWind && tmpIsWeather){
                            setWindOrWeatherDailySelect(WindOrWeatherSelectEnum.HAVEBOTH);
                        }
                        else if(tmpIsWind && !tmpIsWeather){
                            setWindOrWeatherDailySelect(WindOrWeatherSelectEnum.HAVEWIND);
                        }
                        else if(!tmpIsWind && tmpIsWeather){
                            setWindOrWeatherDailySelect(WindOrWeatherSelectEnum.HAVEWEATHER);
                        }
                        else{
                            setWindOrWeatherDailySelect(WindOrWeatherSelectEnum.HAVENONE);
                        }
                    });
                    result = await getForecastDailyDataFunc(item,AgregationEnum.DAILY);
                } else if (item?.aggregation === AgregationEnum.EIGHTHOURLY) {
                    let tmpIsWind = false;
                    let tmpIsWeather = false;
                    item?.variablesForArray?.forEach((item)=>{
                        if(item === 'WindDirection_8HourlyAvg (Deg)'){
                            tmpIsShowSpeedLegendChart8Hourly = true;
                            tmpIsWind = true;
                        }
                        if(item === 'PictoCode_8Hourly'){
                            tmpIsWeather = true;
                        }
                        if(tmpIsWind && tmpIsWeather){
                            setWindOrWeather8HourlySelect(WindOrWeatherSelectEnum.HAVEBOTH);
                        }
                        else if(tmpIsWind && !tmpIsWeather){
                            setWindOrWeather8HourlySelect(WindOrWeatherSelectEnum.HAVEWIND);
                        }
                        else if(!tmpIsWind && tmpIsWeather){
                            setWindOrWeather8HourlySelect(WindOrWeatherSelectEnum.HAVEWEATHER);
                        }
                        else{
                            setWindOrWeather8HourlySelect(WindOrWeatherSelectEnum.HAVENONE);
                        }
                    });
                    result = await getForecastDailyDataFunc(item,AgregationEnum.EIGHTHOURLY);
                }
                else if (item?.aggregation === AgregationEnum.HOURLY) {
                    result = await getForecastDailyDataFunc(item,AgregationEnum.HOURLY);
                }
                setIsShowSpeedLegendChartDaily(tmpIsShowSpeedLegendChartDaily);
                setIsShowSpeedLegendChart8Hourly(tmpIsShowSpeedLegendChart8Hourly);

                // 返回一个对象，其中包含结果和聚合类型
                return { aggregation: item.aggregation, data: result };
            });

            // 使用 Promise.all 等待所有的 promise 完成并获取结果
            const results = await Promise.all(promises);

            // 根据聚合类型设置状态
            results.forEach(({ aggregation, data }) => {
                if(forecastType === ChartsOrTablesEnum.CHARTS){
                    if (aggregation === AgregationEnum.DAILY) {
                        setFinalForecastChartDailyData(prevState => [...prevState, ...(data || [])]);
                    } else if (aggregation === AgregationEnum.EIGHTHOURLY) {
                        setFinalForecastChart8HourlyData(prevState => [...prevState, ...(data || [])]);
                    }else if (aggregation === AgregationEnum.HOURLY) {
                        setFinalForecastChartHourlyData(prevState => [...prevState, ...(data || [])]);
                    }
                }
                else if(forecastType === ChartsOrTablesEnum.TABLES){
                    if (aggregation === AgregationEnum.DAILY) {
                        setFinalForecastTableDailyData(prevState => [...prevState, ...(data || [])]);
                    } else if (aggregation === AgregationEnum.EIGHTHOURLY) {
                        setFinalForecastTable8HourlyData(prevState => [...prevState, ...(data || [])]);
                    }else if (aggregation === AgregationEnum.HOURLY) {
                        setFinalForecastTableHourlyData(prevState => [...prevState, ...(data || [])]);
                    }
                }
            });

            console.log('forecast merged results', results);
            return results; // 返回所有结果
        } catch (error) {
            console.error('Failed to get forecast data, error is: ', error);
            return null;
        }
    };

    // get Forecast Daily data
    const getForecastDailyDataFunc = async(requestModel:IForecastChartOrTableModel,type: string)=>{
        try{
            let tmpData:IGetHistoricalOrForecastDataResModel[] = null;
            const tmpForecastDays = requestModel?.forecastDays ? requestModel?.forecastDays -1 : 6;
            if(type === AgregationEnum.DAILY){
                const res = await agriAlertGetForecastData({
                    forecastVariables: requestModel?.variables,
                    // requestVariables: 'precipitation;soil_temperature;temperature_daily_min;relative_humidity;temperature_daily_average;wind_speed;soil_moilsture;wind_gust;temperature_daily_max',
                    lat: lat,
                    lng: lng,
                    startDate: moment().format('YYYY-MM-DD'),
                    endDate: moment().add(tmpForecastDays,'days').format('YYYY-MM-DD'),
                    languageCode: language,
                    unit: unit || 'metric'
                });
                tmpData = res.data;
            }
            else if(type === AgregationEnum.EIGHTHOURLY){
                const res = await agriAlertGetForecast8HourlyData({
                    forecastVariables: requestModel?.variables,
                    // requestVariables: 'precipitation;soil_temperature;temperature_daily_min;relative_humidity;temperature_daily_average;wind_speed;soil_moilsture;wind_gust;temperature_daily_max',
                    lat: lat,
                    lng: lng,
                    startDate: moment().format('YYYY-MM-DD'),
                    endDate: moment().add(tmpForecastDays,'days').format('YYYY-MM-DD'),
                    languageCode: language,
                    unit: unit || 'metric'
                });
                tmpData = res.data;
            }
            else if(type === AgregationEnum.HOURLY){
                const res = await agriAlertGetForecastHourlyData({
                    forecastVariables: requestModel?.variables,
                    // requestVariables: 'precipitation;soil_temperature;temperature_daily_min;relative_humidity;temperature_daily_average;wind_speed;soil_moilsture;wind_gust;temperature_daily_max',
                    lat: lat,
                    lng: lng,
                    startDate: moment().format('YYYY-MM-DD'),
                    endDate: moment().add(tmpForecastDays,'days').format('YYYY-MM-DD'),
                    languageCode: language,
                    unit: unit || 'metric'
                });
                tmpData = res.data;
            }

            // const tmpData = res.data;
            tmpData.forEach((item,index)=>{
                // change week name
                item?.weeks?.forEach((innerItem,innerIndex)=>{
                    innerItem.weekName = getWeekTranslate(translateValue,innerItem?.weekIndex);
                });
                if(item.unit === 'C'){
                    item.unit = '°C';
                }
                // change series name
                if(item?.code === 11){
                    if(type === AgregationEnum.DAILY){
                        if(item?.aggregation === 'min'){
                            item.variable = translateValue?.temperature_daily_min;
                        }
                        if(item?.aggregation === 'max'){
                            // item.variable = 'Temperature Max';
                            item.variable = translateValue?.temperature_daily_max;
                        }
                        if(item?.aggregation === 'mean'){
                            // item.variable = 'Temperature Average';
                            item.variable = translateValue?.temperature_daily_average;
                        }
                    }
                    if(type === AgregationEnum.EIGHTHOURLY){
                        if(item?.aggregation === 'min'){
                            item.variable = translateValue?.temperature_8hourly_min;
                        }
                        if(item?.aggregation === 'max'){
                            // item.variable = 'Temperature Max';
                            item.variable = translateValue?.temperature_8hourly_max;
                        }
                        if(item?.aggregation === 'mean'){
                            // item.variable = 'Temperature Average';
                            item.variable = translateValue?.temperature_8hourly_average;
                        }
                    }
                    if(type === AgregationEnum.HOURLY){
                        item.variable = translateValue?.air_temperature;
                    }
                }

                if(item.code === 61){
                    item.variable = translateValue?.precipitation;
                }
                if(item.code === 52){
                    item.variable = translateValue?.relative_humidity;
                }
                if(item.code === 32){
                    item.variable = translateValue?.wind_speed;
                }
                if(item.code === 85){
                    item.variable = translateValue?.soil_temperature;
                }
                if(item.code === 144){
                    item.variable = translateValue?.soil_moilsture;
                }
                if(item.code === 180){
                    item.variable = translateValue?.wind_gust;
                }
                // new variables for forecast and historical
                if(item.code === 71){
                    item.variable = translateValue?.cloud_cover;
                }
                if(item.code === 31){
                    item.variable = translateValue?.wind_direction;
                }
                if(item.code === 204){
                    item.variable = translateValue?.radiation;
                }
                if(item.code === 17){
                    item.variable = translateValue?.dewpoint;
                }
                if(item.code === 1){
                    item.variable = translateValue?.air_pressure;
                }
                if(item.code === 730){
                    item.variable = translateValue?.growing_degree_days;
                }
                if(item.code === 2){
                    item.variable = translateValue?.precipitation_risk;
                }
                if(item.code === 3){
                    item.variable = translateValue?.shower_risk;
                }
                if(item.code === 4){
                    item.variable = translateValue?.thunderstorm_risk;
                }
            });

            console.log('forecast merged daily results', tmpData);
            return tmpData;
        }
        catch(error){
            console.log(`get forecast daily data failed, error is ${error}`);
        }
    };

    useEffect(()=>{
        if(showForecast && translateValue && selectedForecastChartsOrTables?.length >= 1){
            getForecastChartsOrTablesListDataFunc();
        }
    },[showForecast,translateValue]);

    useEffect(()=>{
        if(isShowSpeedLegendChartDaily ||
            isShowSpeedLegendChart8Hourly
        ){
            let tmpSpeedType = null;
            if(language === 'el'){
                tmpSpeedType = SpeedUnitEnum.BEAUFORT;
            }
            else if(unit === 'metric'){
                tmpSpeedType = SpeedUnitEnum.KMH;
            }
            else if(unit === 'imperial'){
                tmpSpeedType = SpeedUnitEnum.MPH;
            }
            setSpeedType(tmpSpeedType);
        }
    },[isShowSpeedLegendChartDaily,isShowSpeedLegendChart8Hourly,unit,language]);


    return(
        showForecast ?
            <div style={{overflow:'auto'}}>
                <IF show={forecastType === ChartsOrTablesEnum.CHARTS}>
                    {/* Forecast Chart Daily */}
                    <IF show={finalForecastChartDailyData?.length >= 1}>
                        <div className="forecast-chart content-basic chart-or-table-top">
                            <div className="historical-chart-title common-title">
                                {translateValue?.forecast_daily_chart || 'Forecast Daily Chart'}
                            </div>
                            <div style={{position: 'relative'}}>
                                {
                                    isShowSpeedLegendChartDaily &&
                                    <TemplateImageLegend
                                        speedType={speedType}
                                        translateData={translateValue}
                                        left={0}
                                    />
                                }
                                <TemplatePreviewChart
                                    id = "forecastChartDailyRef"
                                    echartData={finalForecastChartDailyData}
                                    translateData={translateValue}
                                    chartsType={AgregationEnum.DAILY}
                                    containerHeight={500 + windOrWeatherDailySelect}
                                    windOrWeatherSelect={windOrWeatherDailySelect}
                                    historicalOrForecastType={HistoricalOrForecastEnum.FORECAST}
                                />
                            </div>

                        </div>
                    </IF>
                    {/* Forecast Chart 8 Hourly */}
                    <IF show={finalForecastChart8HourlyData?.length >= 1}>
                        <div className="forecast-chart content-basic chart-or-table-top">
                            <div className="historical-chart-title common-title">
                                {translateValue?.forecast_8hourly_chart || 'Forecast 8-Hourly Chart'}
                            </div>
                            <div style={{position: 'relative'}}>
                                {
                                    isShowSpeedLegendChart8Hourly &&
                                    <TemplateImageLegend
                                        speedType={speedType}
                                        translateData={translateValue}
                                        left={0}
                                    />
                                }
                                <TemplatePreviewChart
                                    id = "forecastChart8HourlyRef"
                                    echartData={finalForecastChart8HourlyData}
                                    translateData={translateValue}
                                    chartsType={AgregationEnum.EIGHTHOURLY}
                                    containerHeight={490 + 70 + windOrWeather8HourlySelect}
                                    windOrWeatherSelect={windOrWeather8HourlySelect}
                                    historicalOrForecastType={HistoricalOrForecastEnum.FORECAST}
                                />
                            </div>
                        </div>
                    </IF>
                    {/* Forecast Chart Hourly */}
                    <IF show={finalForecastChartHourlyData?.length >= 1}>
                        <div className="forecast-chart content-basic chart-or-table-top">
                            <div className="historical-chart-title common-title">
                                {translateValue?.forecast_hourly_chart || 'Forecast Houlry Chart'}
                            </div>
                            <TemplatePreviewChart
                                id = "forecastChartHourlyRef"
                                echartData={finalForecastChartHourlyData}
                                translateData={translateValue}
                                chartsType={AgregationEnum.HOURLY}
                                // containerHeight={490 + 70}
                                containerHeight={500}
                                historicalOrForecastType={HistoricalOrForecastEnum.FORECAST}
                            />
                        </div>
                    </IF>
                </IF>
                <IF show={forecastType === ChartsOrTablesEnum.TABLES}>
                    {/* show Forecast Table Daily */}
                    <IF show={finalForecastTableDailyData?.length >= 1}>
                        {/* Forecast Table */}
                        <div className="forecast-table content-basic chart-or-table-top">
                            <div className="historical-chart-title common-title">
                                {translateValue?.forecast_daily_table || 'Forecast Daily Table'}
                            </div>
                            <table className="foreacst-table-container">
                                <thead>
                                    <tr>
                                        <td className="thead-tr-var basic-first-td"
                                            style={{backgroundColor: 'rgb(221 243 221)'}}
                                        >{translateValue?.variables || 'Variables'}</td>
                                        {
                                            finalForecastTableDailyData && finalForecastTableDailyData?.[0]?.date.map((item,index)=>{
                                                return(
                                                    <>
                                                        <td className="thead-tr-day"
                                                            style={{backgroundColor: 'rgb(221 243 221)'}}
                                                        >{`${item} ${finalForecastTableDailyData?.[0]?.weeks[index].weekName}`}</td>
                                                    </>
                                                );
                                            })
                                        }
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        finalForecastTableDailyData &&finalForecastTableDailyData?.map((item,index)=>{
                                            const tmpUnitsValue = item?.unit ? `(${item?.unit})` : '';
                                            return(
                                                <>
                                                    <tr>
                                                        <td className="tdoby-tr-var basic-first-td">{`${item?.variable} ${tmpUnitsValue}`}</td>
                                                        {
                                                            item?.values?.map((dataItem,dataIndex)=>{
                                                                return(
                                                                    <>
                                                                        <td className="tdoby-tr-day">{dataItem}</td>
                                                                    </>
                                                                );
                                                            })
                                                        }
                                                    </tr>
                                                </>
                                            );
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </IF>
                    {/* show Forecast Table 8-Hourly */}
                    <IF show={finalForecastTable8HourlyData?.length >= 1}>
                        {
                            <div className="forecast-table content-basic chart-or-table-top">
                                <div className="historical-chart-title common-title">
                                    {translateValue?.forecast_8hourly_table || 'Forecast 8-Hourly Table'}
                                </div>
                                {
                                    finalForecastTable8HourlyData?.map((item,index)=>{
                                        const tmpUnit = item?.code === 31 ? '' : `(${item?.unit})`;
                                        return(
                                            <>
                                                <div key={`forecast-table-hourly-${index}-${item?.code}`} className='spray-list-container'>
                                                    {/* <div className='spray-item-name' style={{margin: '5px 0px'}}>{item?.variable}</div> */}
                                                    <table className="spray-table-container">
                                                        <thead>
                                                            <tr
                                                                style={{backgroundColor: 'rgb(221 243 221)'}}
                                                            >
                                                                <td className="thead-tr-var basic-first-td-8-hourly"
                                                                >
                                                                    {`${item?.variable} ${tmpUnit}`}
                                                                </td>
                                                                {
                                                                    Array.from({length: 3}, (_, i) => (i * 8) < 10? `0${i * 8}` : `${i*8}`).map((item)=>{
                                                                        return(
                                                                            <>
                                                                                <td className="basic-td-8-hourly">{item}</td>
                                                                            </>
                                                                        );
                                                                    })
                                                                }
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                item?.hourlyValues?.map((innerItem,index)=>{
                                                                    const tmpDate = `${item?.date?.[index]} ${item?.weeks?.[index]?.weekName}`;
                                                                    return(
                                                                        <>
                                                                            <tr key={index + '-' + tmpDate}>
                                                                                <td className="tdoby-tr-var basic-first-td-8-hourly">
                                                                                    {`${tmpDate}`}
                                                                                </td>
                                                                                {/* show detail value */}
                                                                                {
                                                                                    innerItem?.map((innerValueItem,innerValueIndex)=>{
                                                                                        return(
                                                                                            <td key={innerValueItem + '-' + innerValueIndex}
                                                                                                className="basic-td-8-hourly"
                                                                                                style={{fontSize: item.fontSize}}
                                                                                                // style={{backgroundColor:innerItem?.backColor}}
                                                                                            >
                                                                                                {innerValueItem}
                                                                                            </td>
                                                                                        );
                                                                                    })
                                                                                }
                                                                            </tr>
                                                                        </>
                                                                    );
                                                                })
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </>
                                        );
                                    })
                                }
                            </div>
                        }
                    </IF>
                    {/* show Forecast Table Hourly */}
                    <IF show={finalForecastTableHourlyData?.length >= 1}>
                        {
                            <div className="forecast-table content-basic chart-or-table-top">
                                <div className="historical-chart-title common-title">
                                    {translateValue?.forecast_hourly_table || 'Forecast Hourly Table'}
                                </div>
                                {
                                    finalForecastTableHourlyData?.map((item,index)=>{
                                        const tmpUnit = item?.code === 31 ? '' : `(${item?.unit})`;
                                        return(
                                            <>
                                                <div key={`forecast-table-hourly-${index}-${item?.code}`} className='spray-list-container'>
                                                    {/* <div className='spray-item-name' style={{margin: '5px 0px'}}>{item?.variable}</div> */}
                                                    <table className="spray-table-container">
                                                        <thead>
                                                            <tr
                                                                style={{backgroundColor: 'rgb(221 243 221)'}}
                                                            >
                                                                <td className="thead-tr-var basic-first-td"
                                                                >
                                                                    {`${item?.variable} ${tmpUnit}`}
                                                                </td>
                                                                {
                                                                    Array.from({length: 24}, (_, i) => i < 10? `0${i}` : `${i}`).map((item)=>{
                                                                        return(
                                                                            <>
                                                                                <td className="basic-td-hourly">{item}</td>
                                                                            </>
                                                                        );
                                                                    })
                                                                }
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                item?.hourlyValues?.map((innerItem,index)=>{
                                                                    const tmpDate = `${item?.date?.[index]} ${item?.weeks?.[index]?.weekName}`;
                                                                    return(
                                                                        <>
                                                                            <tr key={index + '-' + tmpDate}>
                                                                                <td className="tdoby-tr-var basic-first-td">
                                                                                    {`${tmpDate}`}
                                                                                </td>
                                                                                {/* show detail value */}
                                                                                {
                                                                                    innerItem?.map((innerValueItem,innerValueIndex)=>{
                                                                                        return(
                                                                                            <td key={innerValueItem + '-' + innerValueIndex}
                                                                                                className=" basic-td-hourly"
                                                                                                style={{fontSize: item.fontSize}}
                                                                                                // style={{backgroundColor:innerItem?.backColor}}
                                                                                            >
                                                                                                {innerValueItem}
                                                                                            </td>
                                                                                        );
                                                                                    })
                                                                                }
                                                                            </tr>
                                                                        </>
                                                                    );
                                                                })
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </>
                                        );
                                    })
                                }
                            </div>
                        }
                    </IF>
                </IF>

            </div>
            :
            null
    );
};

export default TemplateForecast;

